import { Accordion, AccordionTab } from 'primereact/accordion';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { allowExpansion, dueBodyTemplate, statusBodyTemplate } from './coachingToDo-service';
import { ToDoData } from './CoachingToDo';
import { useGetCoachingToDoDetailsQuery } from './CoachingToDoSlice';
import { SelectedToDoViewDataType } from '../../features/coaching/toDoView/toDoGrid/ToDoGrid';

interface CoachingToDoViewPropType {
    visible: boolean;
    setVisible: (e: boolean) => void;
    selectedToDoViewData: SelectedToDoViewDataType | null;
}

const CoachingToDoView = ({ visible, setVisible, selectedToDoViewData }: CoachingToDoViewPropType) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const { data: toDoData } = useGetCoachingToDoDetailsQuery(
        { employeenumber: selectedToDoViewData?.employeeNumber },
        { skip: !selectedToDoViewData?.employeeNumber }
    );
    const DialogueHeader = <div>To Do</div>;
    const rowExpansionTemplate = (data: ToDoData) => {
        return (
            <InputTextarea
                readOnly
                className="borderRadius8 w-100 todoview-readonlydesc"
                value={data.to_do_description}
                maxLength={4000}
                autoResize={false}
            />
        );
    };
    const footerContent = (
        //For Latest ToDos
        <Accordion data-testid="accordion-control" style={{ marginTop: '1rem' }}>
            <AccordionTab header="Latest To Dos">
                <DataTable
                    value={toDoData?.data}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    rowExpansionTemplate={rowExpansionTemplate}
                >
                    <Column header="Title" field={'to_do_title'} />
                    <Column header="Due" field={'due_date'} body={dueBodyTemplate} />
                    <Column header="Status" field={'coaching_to_do_status_id'} body={statusBodyTemplate} />
                    <Column expander={allowExpansion} />
                </DataTable>
            </AccordionTab>
        </Accordion>
    );

    return (
        <div className="card flex justify-content-center">
            <Dialog
                header={DialogueHeader}
                visible={visible}
                style={{ width: '50vw' }}
                onHide={() => setVisible(false)}
                footer={footerContent}
                id="todView-dialog"
            >
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <h6>Title</h6>
                            <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                {selectedToDoViewData?.title}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-12">
                        <div className="form-group">
                            <h6>Description</h6>
                            <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                <InputTextarea
                                    readOnly
                                    className="borderRadius8 w-100 todoview-readonlydesc"
                                    value={selectedToDoViewData?.description}
                                    maxLength={4000}
                                    autoResize={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-6">
                        <div className="form-group">
                            <h6>Start Date</h6>
                            <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                {selectedToDoViewData?.startDate}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <h6>End Date</h6>
                            <div style={{ marginLeft: '8px', marginTop: '5px' }}>
                                {selectedToDoViewData?.endDate}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default CoachingToDoView;
